import * as React from "react";
import { OriginSelector } from "./OriginSelector";
import { useLocalization } from "@shared-ui/localization-context";

export interface DestinationSuggestionsHeadingProps {
  origin: string;
  month: string;
  disableOriginSelector: boolean;
}

export const Heading: React.SFC<DestinationSuggestionsHeadingProps> = (props: DestinationSuggestionsHeadingProps) => {
  const { origin, month, disableOriginSelector } = props;

  let finalSubtitle;
  const { formatText } = useLocalization();
  const title = formatText("destinationSuggestions.title");
  const subtitle = formatText(`destinationSuggestions.subtitle.${month}`, "{{origin}}");

  if (subtitle) {
    const subtitleParts = subtitle.split("{{origin}}");
    // Inject the OriginSelector component in the removed origin template
    finalSubtitle = [
      subtitleParts[0],
      <OriginSelector key={"origin-selector"} origin={origin} disableOriginSelector={disableOriginSelector} />,
      subtitleParts[1],
    ];
  }

  return (
    <div className="s-l-padding-three m-l-padding-three">
      <div className="title-wrapper all-t-padding-three">
        <h2 className="title uitk-type-display-700">{title}</h2>
      </div>
      <div className="subtitle-wrapper all-b-margin-three">
        {finalSubtitle && <span className="subtitle uitk-type-300">{finalSubtitle}</span>}
      </div>
    </div>
  );
};
